import GoogleMdmApi from 'client/api/v2/GoogleMdmApi';
import Vue from 'vue';

export const createGoogleModule = () => ({
  namespaced: true,

  state: {
    googleEmmEnterpriseObj: null,
    isNewAndroidApp: false,
    isGoogleEmmEnrolled: false,
    numberOfApps: 0,
    packageName: '',
    signUpUrl: '',
  },

  actions: {
    deleteEnterprise(context, payload) {
      return GoogleMdmApi.deleteEnterprise(payload);
    },

    getAndroidDeviceCount(context, payload) {
      return GoogleMdmApi.getAndroidDeviceCount(payload.enterpriseId, payload.filters);
    },

    getConnectionStatus(context, enterpriseId) {
      return GoogleMdmApi.getConnectionStatus(enterpriseId);
    },

    getDeviceDetails(context, deviceId) {
      return GoogleMdmApi.getDeviceDetails(deviceId);
    },

    getEnterprise() {
      return GoogleMdmApi.getEnterprise();
    },

    getPolicyResults(context, payload) {
      return GoogleMdmApi.getPolicyResults(payload);
    },

    getSignUpUrl() {
      return GoogleMdmApi.getSignUpUrl();
    },

    getQRLink(context, payload) {
      return GoogleMdmApi.getQRLink(payload);
    },

    getWebToken(context, payload) {
      return GoogleMdmApi.getWebToken(payload);
    },

    postEnterprise(context, payload) {
      return GoogleMdmApi.postEnterprise(payload);
    },

    updateAddNewAppState({ commit }, value) {
      commit('UPDATE_NEW_ANDROID_APP', value);
    },

    updateEnrollState({ commit }, value) {
      commit('UPDATE_ENROLL_STATE', value);
    },

    updateEnterprise(context, payload) {
      return GoogleMdmApi.updateEnterprise(payload.enterpriseObjectId, payload.data);
    },

    updateGoogleEmmEnterpriseObjState({ commit }, value) {
      commit('UPDATE_GOOGLE_EMM_ENTERPRISE_STATE', value);
    },

    updateNumberOfAndroidApps({ commit }, value) {
      commit('UPDATE_NUMBER_OF_ANDROID_APP', value);
    },

    updatePackageName({ commit }, value) {
      commit('UPDATE_PACKAGE_NAME', value);
    },

    updateSignUpUrl({ commit }, value) {
      commit('UPDATE_SIGNUP_URL', value);
    },
  },

  mutations: {
    UPDATE_ENROLL_STATE(state, value) {
      Vue.set(state, 'isGoogleEmmEnrolled', value);
    },

    UPDATE_GOOGLE_EMM_ENTERPRISE_STATE(state, value) {
      Vue.set(state, 'googleEmmEnterpriseObj', value);
    },

    UPDATE_PACKAGE_NAME(state, value) {
      Vue.set(state, 'packageName', value);
    },

    UPDATE_SIGNUP_URL(state, value) {
      Vue.set(state, 'signUpUrl', value);
    },

    UPDATE_NEW_ANDROID_APP(state, value) {
      Vue.set(state, 'isNewAndroidApp', value);
    },

    UPDATE_NUMBER_OF_ANDROID_APP(state, value) {
      Vue.set(state, 'numberOfApps', value);
    },
  },
});

export default createGoogleModule();
